function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.083c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm-6 7c0-3.31 2.69-6 6-6 1.595 0 3.04.63 4.115 1.645l-8.47 8.47A5.976 5.976 0 012 8.082zm6 6a5.94 5.94 0 01-3.61-1.22l8.39-8.39A5.971 5.971 0 0114 8.083c0 3.31-2.69 6-6 6z",
    fill: props.color
  }));
}

export default SvgIconNone;